



























import { defineComponent } from '@nuxtjs/composition-api';
import BaseButton from '@shared/components/@atoms/BaseButton/BaseButton.vue';
export default defineComponent({
  name: 'BaseCallToAction',
  components: {
    BaseButton,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: '',
    },
    link: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: '',
    },
    background: {
      type: String,
      default: '',
    },
    image: {
      type: [String, Object],
      default: '',
    },
  },
  computed: {
    style(): any {
      const image = this.image;
      const background = this.background;
      return {
        // @ts-ignore migrated from ui-library
        '--_call-to-action-background-image': image.mobile
          ? // @ts-ignore migrated from ui-library
            `url(${image.mobile})`
          : `url(${image})`,
        // @ts-ignore migrated from ui-library
        '--_call-to-action-background-desktop-image': image.desktop && `url(${image.desktop})`,
        '--_call-to-action-background-color': background,
      };
    },
  },
});
